// Sport switch for the playing-surface renderer.
//
// The waterpolo pool and the handball court differ enough (court geometry,
// markings, colours, second goalkeeper) that they live in two separate files
// with an identical `PoolElement` props interface. This module re-exports the
// right one based on the build-time sport, so every import site
// (`import { PoolElement } from './Pool'`) keeps working unchanged.
import { isHandball } from './sportConfig';
import { PoolElement as WaterpoloPoolElement } from './Pool.waterpolo';
import { PoolElement as HandballPoolElement } from './Pool.handball';

export const PoolElement = isHandball
  ? HandballPoolElement
  : WaterpoloPoolElement;
